"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StyledWarning = _styledComponents["default"].p.withConfig({
  displayName: "Warning__StyledWarning",
  componentId: "sc-1bp9yfz-0"
})(["", ""], function (props) {
  var _props$theme = props.theme,
    palette = _props$theme.palette,
    typography = _props$theme.typography,
    spacing = _props$theme.spacing;
  return (0, _styledComponents.css)(["color:", ";font-size:", ";line-height:", ";padding:0 ", ";"], palette.validation.warning, typography.size.table, typography.lineHeight.misc, spacing.tiny);
});
var Warning = function Warning(_ref) {
  var message = _ref.message,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledWarning, {
    className: className
  }, message);
};
Warning.defaultProps = {
  className: ''
};
Warning.propTypes = {
  message: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string
};
var _default = exports["default"] = Warning;